
/* eslint-disable object-property-newline */
import Vue from 'vue';
import Router from 'vue-router';

import Marketing from './components/marketing/Marketing.vue';
import MarketingPost from './components/marketing/MarketingPost.vue';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	//base: process.env.VUE_APP_BASEURL,
	routes:
		[
			{ path: '/', name: 'marketing', component: Marketing },
			{ path: '/:id', props: true, name: 'marketingPost', component: MarketingPost },

			{ path: '*', redirect: { name: 'marketing' } },
		]
});


export default router;
